export function listPayorsV2(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v2/payors',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
